/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M209.455 304.308c0 10.327 4.951 19.21 12.307 25.378v53.5c0 11.742 9.507 21.22 21.22 21.22s21.219-9.478 21.219-21.22v-53.528c7.356-6.14 12.279-15.023 12.279-25.35 0-18.503-14.995-33.498-33.498-33.498-18.504 0-33.527 14.995-33.527 33.498z" />
      <path d="M384.663 461.375c0 4.498-3.14 8.261-6.875 8.261H108.192c-3.763 0-6.932-3.763-6.932-8.261V194.523c0-4.47 3.169-8.262 6.932-8.262h269.596c3.735 0 6.875 3.792 6.875 8.262v266.852zM160.25 125.518c0-45.607 37.12-82.726 82.727-82.726 45.607 0 82.726 37.12 82.726 82.726v18.305H160.25v-18.305zm207.892 18.305v-18.305C368.14 56.485 312.009.353 242.976.353 173.97.353 117.81 56.485 117.81 125.518v18.305h-9.62c-27.216 0-49.37 22.747-49.37 50.7v266.852c0 27.953 22.154 50.7 49.37 50.7h269.597c27.19 0 49.314-22.747 49.314-50.7V194.523c0-27.953-22.125-50.7-49.314-50.7h-9.647z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconLock = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconLock.defaultProps = {
  theme,
};
IconLock.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconLock.displayName = 'IconLock';
export { IconLock };
